module.exports = __webpack_public_path__ + "img/info.51d5156a.svg";